import { BlogPost } from '@/types/Blog';
import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';
import getBlogPosts from './getBlogPosts';

async function getBlogPostsUseQuery(
  context: QueryFunctionContext<QueryKey>
): Promise<BlogPost[]> {
  const [name, query, locale] = context.queryKey as [string, string, string];
  return await getBlogPosts(query, locale);
}

export default getBlogPostsUseQuery;
